module.exports = __webpack_public_path__ + "img/privacy-careers-non-portale.c1d3800d.png";